module.exports = __webpack_public_path__ + "img/done.95a869c5.svg";